<div class="layout-topbar">
  <button
    #menubutton
    type="button"
    class="topbar-menubutton"
    (click)="onMenuToggle()"
    aria-controls="app-sidebar"
    [attr.aria-expanded]="layoutService.state.staticMenuMobileActive"
    [attr.aria-label]="layoutService.state.staticMenuMobileActive ? 'Chiudi menu' : 'Apri menu'">
    <span></span>
  </button>

  <a class="app-logo mr-auto" routerLink="/">
    <img src="logo.png" alt="Logo" width="120px">
    <!--
    <svg version="1.1" id="logo-menu" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         color="white" fill="white" xml:space="preserve" width="120px" height="68px"
         x="0px" y="0px"  viewBox="0 0 120 68" style="enable-background:new 0 0 120 68;"
         xml:space="preserve">
        <g>
          <polygon
            points="76.6,2.3 58.9,2.3 45.7,25 32.6,2.3 27,2.3 45.7,34.9 61.8,7.8 68,7.8 48.9,40.1 51.8,45.3 	"></polygon>
          <polygon points="21.2,2.5 3.5,2.5 40.1,65.7 43,60.6 45.9,55.5 48.9,50.3 	"></polygon>
          <path d="M84.8,2.3h-2.9l-3,5.2l-3.3,5.8l0,0l-2.5,4.4h11.7c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3H54.1l-3,5.2l0,0
            l-3.5,6.1l-2.4,4.1h39.6c17.5,0,31.7-14.2,31.7-31.7C116.5,16.5,102.3,2.3,84.8,2.3z"></path>
        </g>
    </svg>
    -->
  </a>

  <div>
    <p>
      <strong>Catalogo</strong>
    </p>
  </div>
</div>
